"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FillScreen = _styledComponents["default"].div.withConfig({
  displayName: "FillScreen",
  componentId: "sc-18j83qe-0"
})(["z-index:1;width:100%;height:100%;position:fixed;top:0;left:0;display:flex;justify-content:center;align-items:center;pointer-events:none;& > *{pointer-events:auto;}"]);

var _default = FillScreen;
exports["default"] = _default;